import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format seconds to MM:SS or HH:MM:SS
export function formatTime(seconds, showHours = false) {
  if (seconds < 0) seconds = Math.abs(seconds);
  
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  
  if (showHours || hrs > 0) {
    return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
}

// Parse MM:SS or HH:MM:SS to seconds
export function parseTime(timeStr) {
  const parts = timeStr.split(':').map(Number);
  if (parts.length === 3) {
    return parts[0] * 3600 + parts[1] * 60 + parts[2];
  }
  return parts[0] * 60 + (parts[1] || 0);
}

// Get phase type label in Spanish
export function getPhaseTypeLabel(type) {
  const types = {
    charla: 'Charla',
    pausa: 'Pausa',
    intro: 'Introducción',
    qa: 'Q&A',
    video: 'Video',
    networking: 'Networking',
    otro: 'Otro',
  };
  return types[type] || type;
}

// Get status label in Spanish
export function getStatusLabel(status) {
  const statuses = {
    pending: 'Pendiente',
    active: 'En curso',
    completed: 'Completado',
  };
  return statuses[status] || status;
}

// Get phase type color
export function getPhaseTypeColor(type) {
  const colors = {
    charla: '#3B82F6',
    pausa: '#8B5CF6',
    intro: '#10B981',
    qa: '#F59E0B',
    video: '#EF4444',
    networking: '#EC4899',
    otro: '#6B7280',
  };
  return colors[type] || '#6B7280';
}

// Calculate time difference
export function getTimeDiff(estimated, actual) {
  const diff = actual - estimated;
  const absDiff = Math.abs(diff);
  const formatted = formatTime(absDiff);
  
  if (diff > 0) return { value: diff, label: `+${formatted}`, status: 'overtime' };
  if (diff < 0) return { value: diff, label: `-${formatted}`, status: 'under' };
  return { value: 0, label: '00:00', status: 'ontime' };
}

// Calculate total event duration
export function calculateTotalDuration(phases) {
  return phases.reduce((acc, phase) => acc + phase.duration_seconds, 0);
}

// Get estimated end time
export function getEstimatedEndTime(startTime, phases) {
  const totalSeconds = calculateTotalDuration(phases);
  const endTime = new Date(startTime.getTime() + totalSeconds * 1000);
  return endTime;
}

// Deep clone object
export function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

// Generate initials from name
export function getInitials(name) {
  return name
    .split(' ')
    .slice(0, 2)
    .map(n => n[0])
    .join('')
    .toUpperCase();
}
